import React, { ChangeEvent } from "react";
import Table from "../Table";
import { CONSTANTS } from "../../constants/Constants";
import Button from "../Buttons";
import EduModal from "../EduModal";
import moment from "moment";

interface EducationProps {
  payload: any;
  eduChangeHandler: (e: ChangeEvent, journey: string) => void;
  saveEduHandler: () => void;
  countryOptions: {}[];
  cityOptions: {}[];
  changeLocationHandler: (
    e: ChangeEvent<HTMLSelectElement>,
    state?: "education"
  ) => void;
  isModalOpen: boolean;
  setIsModalOpen: any;
  newEdu: any;
  setNewEdu: any;
  setCurrentItemIndex: any;
  cityError: string;
}

const Education: React.FC<EducationProps> = ({
  payload,
  eduChangeHandler,
  saveEduHandler,
  countryOptions,
  cityOptions,
  changeLocationHandler,
  isModalOpen,
  setIsModalOpen,
  newEdu,
  setCurrentItemIndex,
  setNewEdu,
  cityError,
}) => {
  const filteredRows = payload?.[
    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_EDUCATION
  ]?.map((edu: any) => {
    return {
      imageUrl:
        edu[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_URL],
      institute:
        edu[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.INSTITUTE],
      degree: edu[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DEGREE],
      location: `${edu.city || ""}${edu.country ? `, ${edu.country}` : ""}`,
      startedOn: edu[
        CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STARTED_ON
      ]
        ? moment(
          edu[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STARTED_ON]
        ).format("MMM-YYYY")
        : "",
      endedOn: edu[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON]
        ? moment(
          edu[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON]
        ).format("MMM-YYYY")
        : "",
      status: edu[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS],
    };
  });
  return (
    <>
      <div className="lg:p-6">
        <h2 className="text-2xl font-semibold mb-4">
          {CONSTANTS.EDUCATION_HEADING_TXT}
        </h2>
        <div className="overflow-auto">

          <Table
            tableHeader={filteredRows.length > 0 ? [
              "",
              CONSTANTS.INSTITUTE_TXT,
              CONSTANTS.DEGREE_TXT,
              CONSTANTS.LOCATION_TXT,
              CONSTANTS.STARTED_ON_TXT,
              CONSTANTS.ENDED_ON_TXT,
              CONSTANTS.SHOW_ON_PROFILE_TXT,
            ] : []}
            tableRows={filteredRows}
            draggable={false}
            rowClickHandler={(index) => {
              setNewEdu(
                payload[
                CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                  .RESOURCE_EDUCATION
                ][index]
              );
              setCurrentItemIndex(index);
              setIsModalOpen(true);
            }}
          />
        </div>
        <div className="w-32 mt-4">
          <Button
            btn_label={CONSTANTS.ADD_MORE}
            on_click_handler={() => {
              setIsModalOpen(true);
              setCurrentItemIndex(null);
              setNewEdu({ status: CONSTANTS.ENABLED_TXT.toLocaleUpperCase() });
            }}
            other_classes="!rounded"
          />
        </div>
      </div>
      {isModalOpen && (
        <EduModal
          payload={newEdu}
          countryOptions={countryOptions}
          cityOptions={cityOptions}
          changeLocationHandler={changeLocationHandler}
          eduChangeHandler={eduChangeHandler}
          saveEduHandler={saveEduHandler}
          setIsModalOpen={setIsModalOpen}
          cityError={cityError}
        />
      )}
    </>
  );
};

export default Education;
